import React from "react";
import { useSelector } from "react-redux";
import { useHardCode } from "../../hooks";

export const E404 = () => {
  const settingState = useSelector((state) => state.storeSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const heading = isPureFemale
    ? "404," + PURE_FEMALE_TRANSLATION.error_page.page_not_found
    : `404, page not <br/> found`;
  const desc = isPureFemale
    ? PURE_FEMALE_TRANSLATION.error_page
        .instead_found_eco_friendly_and_painless_returns
    : "instead found eco-friendly and painless returns.";
  const home_btn = isPureFemale
    ? PURE_FEMALE_TRANSLATION.error_page.home
    : "HOME";
  return (
    <div className="container404">
      <div className="seventy404">
        <div className="content404">
          <h1 className="h1404">
            {heading}
            <br />
          </h1>
          <h5 className="h5404">{desc}</h5>
          {!settingState.is404 && (
            <a href="/">
              <button className="pink-btn404">
                <span>{home_btn}</span>
              </button>
            </a>
          )}
        </div>
        <img
          className="carbon-img404"
          src="assets/404_not_found.jpg"
          alt="404"
        />
      </div>
      <div className="thirty404"></div>
    </div>
  );
};
